document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const root = select.closest('[data-product-root]');
  const price = root && root.querySelector('[data-price]');
  const button = root && root.querySelector('[data-add-button]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? button.dataset.availableLabel : button.dataset.soldoutLabel;
  }
});


/* Storefront video download deterrence. Public media is not encrypted. */
;(() => {
  if (window.__storeVideoGuard) return;
    window.__storeVideoGuard = true;
      const protect = (video) => {
          const tokens = new Set((video.getAttribute('controlslist') || '').split(/\s+/).filter(Boolean));
              tokens.add('nodownload');
                  video.setAttribute('controlslist', [...tokens].join(' '));
                      video.setAttribute('draggable', 'false');
                        };
                          const scan = (root) => {
                              if (root.nodeType !== 1 && root.nodeType !== 9) return;
                                  if (root.matches?.('video')) protect(root);
                                      root.querySelectorAll('video').forEach(protect);
                                        };
                                          const preventVideoSave = (event) => {
                                              if (event.composedPath().some(node => node instanceof HTMLVideoElement)) event.preventDefault();
                                                };
                                                  document.addEventListener('contextmenu', preventVideoSave, true);
                                                    document.addEventListener('dragstart', preventVideoSave, true);
                                                      scan(document);
                                                        new MutationObserver(records => {
                                                            for (const record of records) for (const node of record.addedNodes) scan(node);
                                                              }).observe(document.documentElement, {childList: true, subtree: true});
                                                              })();
                                                              